import React from "react";
import { CheckBox } from "devextreme-react/check-box";
import "./style.scss";
import { formatMessage } from "devextreme/localization";

export default function Foreigner({ employee = {}, convertDateTime }) {
  return (
    <div>
      <div className="form-readonly ma-2">
        <div className="form-col">
          <div className="form-group">
            <div className="form-label">{formatMessage("DispatchCompany")}</div>
            <div className="form-value">
              <span>{employee?.DispatchCompany}</span>
            </div>
          </div>
          <div className="form-group">
            <div className="form-label">{formatMessage("AppointFromDate")}</div>
            <div className="form-value">
              <span>{convertDateTime(employee?.AppointFromDate)}</span>
            </div>
          </div>
          <div className="form-group">
            <div className="form-label">{formatMessage("VisaNo")}</div>
            <div className="form-value">
              <span>{employee?.VisaNo}</span>
            </div>
          </div>
          <CheckBox
            defaultValue={employee?.IsVisaFirstTime}
            text={formatMessage("1stVisaExtension")}
            readOnly={true}
            className="mb-2"
          />
          <br />
          <CheckBox
            defaultValue={employee?.IsVisaSecondTime}
            text={formatMessage("2ndVisaExtension")}
            readOnly={true}
            className="mb-2"
          />
          <br />
          <CheckBox
            defaultValue={employee?.IsVisaThirdTime}
            text={formatMessage("3rdVisaExtension")}
            readOnly={true}
            className="mb-2"
          />
          <br />
          <div className="form-group">
            <div className="form-label">{formatMessage("WorkPermitNo")}</div>
            <div className="form-value">
              <span>{employee?.WorkPermitNo}</span>
            </div>
          </div>
          <CheckBox
            defaultValue={employee?.IsWorkPermitFirstTime}
            text={formatMessage("1stWorkPermitExtension")}
            readOnly={true}
            className="mb-2"
          />
          <br />
          <CheckBox
            defaultValue={employee?.IsWorkPermitSecondTime}
            text={formatMessage("2ndWorkPermitExtension")}
            readOnly={true}
            className="mb-2"
          />
          <br />
          <CheckBox
            defaultValue={employee?.IsWorkPermitThirdTime}
            text={formatMessage("3rdWorkPermitExtension")}
            readOnly={true}
            className="mb-2"
          />
          <br />
          <div className="form-group">
            <div className="form-label">{formatMessage("TempResidenceNo")}</div>
            <div className="form-value">
              <span>{employee?.TempResidenceNo}</span>
            </div>
          </div>
          <div className="form-group">
            <div className="form-label">
              {formatMessage("PerAddressAtVietnam")}
            </div>
            <div className="form-value">
              <span>{employee?.PerAddressAtViet}</span>
            </div>
          </div>
          <div className="form-group">
            <div className="form-label">{formatMessage("ContactPerson")}</div>
            <div className="form-value">
              <span>{employee?.ContactPerson}</span>
            </div>
          </div>
        </div>
        <div className="form-col">
          <div className="form-group">
            <div className="form-label">{formatMessage("AppointToDate")}</div>
            <div className="form-value">
              <span>{convertDateTime(employee?.AppointToDate)}</span>
            </div>
          </div>
          <div className="form-group">
            <div className="form-label">{formatMessage("VisaIssueDate")}</div>
            <div className="form-value">
              <span>{employee?.VisaIssueDate}</span>
            </div>
          </div>
          <div className="form-group">
            <div className="form-label">{formatMessage("1stVisaNo")}</div>
            <div className="form-value">
              <span>{employee?.VisaNoFirstTime}</span>
            </div>
          </div>
          <div className="form-group">
            <div className="form-label">{formatMessage("2ndVisaNo")}</div>
            <div className="form-value">
              <span>{employee?.VisaNoSecondTime}</span>
            </div>
          </div>
          <div className="form-group">
            <div className="form-label">{formatMessage("3rdVisaNo")}</div>
            <div className="form-value">
              <span>{employee?.VisaNoThirdTime}</span>
            </div>
          </div>
          <div className="form-group">
            <div className="form-label">
              {formatMessage("WorkPermitFromDate")}
            </div>
            <div className="form-value">
              <span>{convertDateTime(employee?.WorkPermitFromDate)}</span>
            </div>
          </div>
          <div className="form-group">
            <div className="form-label">
              {formatMessage("1stWorkPermitExpired")}
            </div>
            <div className="form-value">
              <span>{employee?.WorkPermitNoFirst}</span>
            </div>
          </div>
          <div className="form-group">
            <div className="form-label">
              {formatMessage("2ndWorkPermitExpired")}
            </div>
            <div className="form-value">
              <span>{employee?.WorkPermitNoSecond}</span>
            </div>
          </div>
          <div className="form-group">
            <div className="form-label">
              {formatMessage("3rdWorkPermitExpired")}
            </div>
            <div className="form-value">
              <span>{employee?.WorkPermitNoThird}</span>
            </div>
          </div>
          <div className="form-group">
            <div className="form-label">
              {formatMessage("TempResidenceExpired")}
            </div>
            <div className="form-value">
              <span>{convertDateTime(employee?.TempResidenceEffectDate)}</span>
            </div>
          </div>
          <div className="form-group">
            <div className="form-label">
              {formatMessage("PhoneNumberInCountry")}
            </div>
            <div className="form-value">
              <span>{employee?.PhoneNumberInCountry}</span>
            </div>
          </div>
          <div className="form-group">
            <div className="form-label">{formatMessage("Relationship")}</div>
            <div className="form-value">
              <span>{employee?.Relationship}</span>
            </div>
          </div>
        </div>
        <div className="form-col">
          <div className="form-group">
            <div className="form-label">{formatMessage("ReturnDate")}</div>
            <div className="form-value">
              <span>{convertDateTime(employee?.ReturnDate)}</span>
            </div>
          </div>
          <div className="form-group">
            <div className="form-label">{formatMessage("VisaExpiredDate")}</div>
            <div className="form-value">
              <span>{convertDateTime(employee?.VisaExpireDate)}</span>
            </div>
          </div>
          <div className="form-group">
            <div className="form-label">
              {formatMessage("1stVisaExpirationDate")}
            </div>
            <div className="form-value">
              <span>{convertDateTime(employee?.VisaFirstExpiredDate)}</span>
            </div>
          </div>
          <div className="form-group">
            <div className="form-label">
              {formatMessage("2ndVisaExpirationDate")}
            </div>
            <div className="form-value">
              <span>{convertDateTime(employee?.VisaSecondExpiredDate)}</span>
            </div>
          </div>
          <div className="form-group">
            <div className="form-label">
              {formatMessage("3rdVisaExpirationDate")}
            </div>
            <div className="form-value">
              <span>{convertDateTime(employee?.VisaThirdExpiredDate)}</span>
            </div>
          </div>
          <div className="form-group">
            <div className="form-label">
              {formatMessage("WorkPermitExpiredDate")}
            </div>
            <div className="form-value">
              <span>{convertDateTime(employee?.WorkPermitExpiredDate)}</span>
            </div>
          </div>
          <div className="form-group">
            <div className="form-label">
              {formatMessage("1stWorkPermitExpired")}
            </div>
            <div className="form-value">
              <span>{convertDateTime(employee?.WorkPermitFirstExpired)}</span>
            </div>
          </div>
          <div className="form-group">
            <div className="form-label">
              {formatMessage("2ndWorkPermitExpired")}
            </div>
            <div className="form-value">
              <span>{convertDateTime(employee?.WorkPermitSecondExpired)}</span>
            </div>
          </div>
          <div className="form-group">
            <div className="form-label">
              {formatMessage("3rdWorkPermitExpired")}
            </div>
            <div className="form-value">
              <span>{convertDateTime(employee?.WorkPermitThirdExpired)}</span>
            </div>
          </div>
          <div className="form-group">
            <div className="form-label">
              {formatMessage("TempResidenceExpired")}
            </div>
            <div className="form-value">
              <span>{convertDateTime(employee?.TempResidenceExpireDate)}</span>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
